import { render, staticRenderFns } from "./AstroDetails.vue?vue&type=template&id=5fd4c830"
import script from "./AstroDetails.vue?vue&type=script&lang=js"
export * from "./AstroDetails.vue?vue&type=script&lang=js"
import style0 from "./AstroDetails.vue?vue&type=style&index=0&id=5fd4c830&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports